import { Lender, LenderContact } from '@/models/bank-models.model';
import { OfficesService } from '@/services/api/franchises.service';
import { LenderContactsService } from '@/services/api/lender-contacts.service';
import { CommonModule } from '@angular/common';
import { Component, effect, EventEmitter, inject, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { Franchise } from 'src/app/models/franchise.model';

@Component({
    selector: 'app-contact-form',
    imports: [
      CommonModule,
      FormsModule,
      InputTextModule,
      SelectModule,
      ButtonModule
    ],
    template: `
    <div class="flex flex-col gap-4 mt-2">
                    <!-- <div class="font-semibold text-xl">Vertical Grid</div> -->
                    <div class="flex flex-wrap gap-4 w-full">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">First Name</label>
                            <input pInputText id="name2" type="text" [(ngModel)]="currentContact().contactFirstName"/>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="email2">Last Name</label>
                            <input pInputText id="email2" type="text" [(ngModel)]="currentContact().contactLastName"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">Phone</label>
                            <input pInputText id="name2" type="text" [(ngModel)]="currentContact().contactPhone"/>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="email2">Email</label>
                            <input pInputText id="email2" type="text" [(ngModel)]="currentContact().contactEmail"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">Lender</label>
                            <p-select [options]="lenders()" optionLabel="Title" optionValue="LenderID" [filter]="true" filterBy="Title" placeholder="Select a Lender" [(ngModel)]="currentContact().LenderID"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">Office</label>
                            <p-select inputId="office" [appendTo]="'body'" [options]="filteredOffices" optionLabel="CityCode" optionValue="FID" [filter]="true" filterBy="CityCode" placeholder="Select a Office" [(ngModel)]="currentContact().FID">
                            </p-select>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4 w-full">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">Address</label>
                            <input pInputText id="name2" type="text" [(ngModel)]="currentContact().addressNumber"/>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="email2">City</label>
                            <input pInputText id="email2" type="text" [(ngModel)]="currentContact().addressCity"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4 w-full">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">State</label>
                            <input pInputText id="name2" type="text" [(ngModel)]="currentContact().addressState"/>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="email2">Zip</label>
                            <input pInputText id="email2" type="text" [(ngModel)]="currentContact().addressZip"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4 w-full">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <button pButton pRipple label="Cancel" class="w-auto" (click)="cancelContact()"></button>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <button pButton pRipple label="Save Changes" class="w-auto" (click)="saveContact()"></button>
                        </div>
                    </div>
                </div>
    `
})
export class ContactFormComponent {
  private lenderContactsService = inject(LenderContactsService);
  private officesService = inject(OfficesService);

  currentContact = signal<LenderContact>(new LenderContact());
  lenders = signal<Lender[]>([]);
  selectedOffice = signal<Franchise | null>(null);

  @Output() close = new EventEmitter<boolean>();

  constructor() {
    effect(() => {
      const contact = this.lenderContactsService.selectedContact();
      if (contact) {
        this.currentContact.set(contact);
      } else {
        this.currentContact.set(new LenderContact(this.lenderContactsService.selectedLender()?.LenderID));
      }
    });
    effect(() => {
      const lenders = this.lenderContactsService.lenders();
      if (lenders.length > 0) {
        this.lenders.set(lenders);
      }
    });

  }

  get filteredOffices() {
    return this.officesService.getFilteredOffices('LenderContacts', 'edit');
  }

  cancelContact() {
    this.lenderContactsService.setContactEdit(false);
    this.resetContact();
    this.close.emit(true);
  }

  resetContact() {
    const contact = this.lenderContactsService.selectedContact();
    if (contact) {
      this.currentContact.set(contact);
    } else {
      this.currentContact.set(new LenderContact(this.lenderContactsService.selectedLender()?.LenderID));
    }
  }

  saveContact() {
    if(this.currentContact().contactId) {
      this.lenderContactsService.updateContact(this.currentContact());
    } else {
      this.lenderContactsService.saveNewContact(this.currentContact());
    }
    this.lenderContactsService.setContactEdit(false);
    this.resetContact();
    this.close.emit(true);
  }

  selectOffice(office: Franchise) {
    this.selectedOffice.set(office);
  }

  selectLender(lender: Lender) {
    this.currentContact().LenderID = lender.LenderID;
    // this.filterOffices(this.officesService.filteredOffices(), lender);
  }

}
